<template>
  <div class="row">
    <div class="col-sm-3">
      <div class="m-t-label">
        {{ modelValue.ruta.nombre }}
        {{ modelValue.nombre }}
        {{ dateToTimeString(modelValue.hora) }}
      </div>
    </div>
    <div class="form-group col-sm-3">
      <label class="control-label required">
        <abbr title="requerido">*</abbr>
        {{ $I18n.t('parada') }}
      </label>
      <selector-parada
        v-model="parada_id"
        :turno-id="modelValue.id"
        @update:model-value="update('parada_id', $event)"
      />
    </div>
    <div class="form-group col-sm-6">
      <label class="control-label required">
        <abbr title="requerido">*</abbr>
        {{ $I18n.t('asiento') }}
      </label>
      <selector-asiento
        v-model="asiento"
        :turno-id="modelValue.id"
        :fecha-inicio="fechaInicio"
        :fecha-fin="fechaFin"
        @update:model-value="update('asiento', $event)"
      >
      </selector-asiento>
    </div>
  </div>
</template>

<script>
import { dateToTimeString } from '../../../libs/dates';
import SelectorParada from './SelectorParada.vue';
import SelectorAsiento from './SelectorAsiento.vue';

export default {
  components: {
    SelectorParada, SelectorAsiento,
  },
  props: {
    fechaInicio: { type: String, required: true },
    fechaFin: { type: String, required: true },
    modelValue: { type: Object, required: true },
  },
  data() {
    return {
      cargaInicialHecha: false,
      turnos: [],
      parada_id: this.modelValue.parada_id,
      asiento: this.modelValue.asiento,
    };
  },
  methods: {
    update(key, value) {
      this.$emit('update:modelValue', { ...this.modelValue, [key]: value });
    },
    dateToTimeString,
  },
};
</script>
